import React, { memo } from 'react';
import { AsOf, Date, FilterBy, ReportHeader, TitleContent, Wrapper } from './Theme';

export const Report = memo(({ Title, FromDate, ToDate, Content, filterData, asOf, tableContainerRef }) => {
    console.log('Rendering Report:', { Title, FromDate, ToDate, Content, filterData, asOf });
    return (
        <Wrapper ref={tableContainerRef ?? null} className='report-print'>
            <ReportHeader>
                <TitleContent>
                    <h1>{Title}</h1>
                    {FromDate && ToDate && Title !== "Aged account receivable summarized by Ledger" && Title !== "Aged Accounts Receivable by Family" &&
                        <Date>
                            Dated between <span>{FromDate} to {ToDate}</span>
                        </Date>}
                    {FromDate && ToDate && (Title === "Aged account receivable summarized by Ledger" || Title === "Aged Accounts Receivable by Family") && <Date>
                        As of <span>{FromDate}</span>
                    </Date>}


                    {filterData && <FilterBy>Filter by
                        <span>
                            {filterData?.filter?.ledger && ` Ledgers: ${filterData?.filter?.ledger?.length === 0 ? 'All' : `(${filterData?.filter?.ledger?.length})`}`}
                            {filterData?.filter?.category && `, Category: ${filterData?.filter?.category?.[0] === '-1' ? 'All' : `(${filterData?.filter?.category?.length})`}`}
                            {filterData?.filter?.billing_type && `, Billing Type: ${filterData?.filter?.billing_type?.[0] === '-1' ? 'All' : `(${filterData?.filter?.billing_type?.length})`}`}
                            {filterData?.filter?.account_type && `, Member: ${filterData?.filter?.account_type?.[0] === '-1' ? 'All' : `(${filterData?.filter?.account_type?.length})`}`}
                            {filterData?.filter?.paymentMethod && `, payment Methods: ${filterData?.filter?.paymentMethod?.[0] === '-1' ? 'All' : `(${filterData?.filter?.paymentMethod?.length})`}`}
                        </span></FilterBy>}

                </TitleContent>

                {asOf && (Title === "Aged account receivable summarized by Ledger" || Title === "Aged Accounts Receivable by Family") && <AsOf><span>Printed on {asOf}</span></AsOf>}
                {asOf && Title !== "Aged account receivable summarized by Ledger" && Title !== "Aged Accounts Receivable by Family" && <AsOf><span>As of {asOf}</span></AsOf>}
            </ReportHeader>
            {Content}
        </Wrapper>
    );
}
)

